/**
 * @description This enumeration represents the event type for the administrator service.
 * @enum
 * @export
 * @name AdminEventTypeEnum
 */
export enum AdminEventTypeEnum {

  // This enumeration value represents the event type for the administrator service when a session is continued.
  SessionContinued,

  // This enumeration value represents the event type for the administrator service when a session is ended.
  SessionEnd,

  // This enumeration value represents the event type for the administrator service when a session is expired.
  SessionExpired,

  // This enumeration value represents the event type for the administrator service when a session is expiring soon.
  SessionExpiring,

  // This enumeration value represents the event type for the administrator service when a session is started.
  SessionStart
}
